<template>
  <div class="topnav noselect">
    <!-- <img
      id="sidebar"
      class="img-button"
      src="../../../public/assets/icons/sidebar.svg"
      @click="groupsToggle"
    /> -->
    <select id="type" v-model="actualUser" class="select-options">
      <option :value="user" v-for="(user, index) in userList.filter(u => u.type === 'standard')" :key="index">{{
        user.username
      }}</option>
    </select>
    <img
      id="editcustomer"
      class="img-button"
      src="../../../public/assets/icons/edit-customer.svg"
      @click="editCustomer"
    />
    <img
      id="addcustomer"
      class="img-button"
      src="../../../public/assets/icons/add-customer.svg"
      @click="addCustomer"
    />
    <img id="logo" src="../../../public/assets/logo-insis.png" />
    <div id="language-block">
      <img
        id="log-out"
        src="../../../public/assets/icons/ita.svg"
        @click="setLanguage('it')"
      />
      <img
        id="log-out"
        src="../../../public/assets/icons/eng.svg"
        @click="setLanguage('en')"
      />
    </div>
    <div id="exit-block" @click="logout">
      <p>Exit</p>
      <img id="log-out" src="../../../public/assets/icons/log-out.svg" />
    </div>
  </div>
</template>
<script>
export default {
  name: "nav-bar-admin",
  data() {
    return {
      showCustomerMenu: true
    };
  },
  props: {
    userList: Array,
    selectedUser: Object
  },
  computed: {
    actualUser: {
      // getter
      get: function() {
        return this.selectedUser;
      },
      // setter
      set: function(newValue) {
        if (newValue) {
          this.$emit("select-customer", newValue._id);
        }
      },
    },
  },
  methods: {
    logout: function() {
      this.$emit("logout");
    },
    groupsToggle: function() {
      this.$emit("groups-toggle");
    },
    setLanguage(lang) {
      this.$root.$i18n.locale = lang;
    },
    addCustomer() {
      this.$emit("add-customer");
    },
    editCustomer() {
      this.$emit("edit-customer");
    },
  },
};
</script>
<style scoped>
/* Add a color to the active/current link */
.topnav a.active {
  background-color: #4caf50;
  color: white;
}

.link-wrapper {
  height: 15px;
}
.topnav {
  background-color: rgb(40, 42, 59);
  border-bottom: solid 1px rgb(80, 84, 105);
  height: 50px;
  text-align: center;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1em;
  align-items: center;
  z-index: 8;
  display: grid;
  overflow: initial;
  grid-template-columns: minmax(200px, 10%) 60px 60px auto ;
}
#logo {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  height: 80%;
}
.img-button {
  padding: 8px;
  width: 50px;
}
.router-link-active {
  background-color: rgb(57, 60, 80);
}

.link {
  border-radius: 8px;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 35px;
  margin-right: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
#exit-block {
  display: flex;
  position: absolute;
  right: 70px;
}
#exit-block > p {
  margin-right: 10px;
  font-weight: 600;
  font-size: 0.8em;
}

#language-block {
  display: flex;
  position: absolute;
  right: 170px;
}
#language-block > img {
  height: 25px;
  padding: 5px;
  cursor: pointer;
}
.vert-divider {
  margin-right: 3vw;
  width: 2px;
  height: 40px;
  background-color: rgba(80, 84, 105, 1);
  position: relative;
  justify-self: center;
}
</style>
